import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { useTranslation } from 'react-i18next';
import akkodisIcon from '../../../assets/images/customers/akkodis.png';
import creditAgricoleIcon from '../../../assets/images/customers/credit-agricole.png';
import dgacIcon from '../../../assets/images/customers/dgac.png';
import edfIcon from '../../../assets/images/customers/edf.png';
import franceTravailIcon from '../../../assets/images/customers/france-travail.png';
import ikeaIcon from '../../../assets/images/customers/ikea.png';
import intersportIcon from '../../../assets/images/customers/intersport.png';
import isereIcon from '../../../assets/images/customers/isere.png';
import ministereIcon from '../../../assets/images/customers/ministere-transition-ecologique.png';
import renaultTrucksIcon from '../../../assets/images/customers/renault-trucks.png';
import saintGobainIcon from '../../../assets/images/customers/saint-gobain.png';
import { PeopleIcon } from '../../icons';
const logos = [{
  src: creditAgricoleIcon,
  alt: 'Crédit Agricole'
}, {
  src: renaultTrucksIcon,
  alt: 'Renault Trucks'
}, {
  src: ministereIcon,
  alt: 'Ministère de la Transition Écologique'
}, {
  src: franceTravailIcon,
  alt: 'France Travail'
}, {
  src: ikeaIcon,
  alt: 'IKEA'
}, {
  src: saintGobainIcon,
  alt: 'Saint-Gobain'
}, {
  src: intersportIcon,
  alt: 'Intersport'
}, {
  src: akkodisIcon,
  alt: 'Akkodis'
}, {
  src: isereIcon,
  alt: 'Isère'
}, {
  src: dgacIcon,
  alt: 'DGAC'
}, {
  src: edfIcon,
  alt: 'EDF'
}];
function BfgDetailsCard({
  event
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 4,
    paddingX: 4,
    paddingY: 5
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      borderBottom: '1px solid #DDE0E7',
      color: '#2c2e30',
      fontSize: 16,
      lineHeight: 1.6,
      paddingBottom: 2
    }
  }, t('commons.challenges.bfg_faq.description')), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement(PeopleIcon, {
    sx: {
      color: '#326AC2',
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      color: '#2c2e30',
      fontSize: 16,
      fontWeight: 700
    }
  }, t('commons.challenges.participants_company', {
    count: event.numberOfParticipants
  }))), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    gap: 1,
    overflow: "auto"
  }, logos.map(({
    src,
    alt
  }) => /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    key: alt,
    sx: {
      filter: 'grayscale(1)',
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: alt,
    src: src,
    style: {
      maxWidth: 90,
      maxHeight: 40,
      objectFit: 'contain'
    }
  }))))));
}
export default BfgDetailsCard;